import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { SidebarStateKey } from 'applications/GSP/layouts/MainLayout/components/Sidebar/store';
import {
  openedMixin,
  closedMixin,
} from 'applications/GSP/layouts/MainLayout/components/Sidebar/utils';

import type { SidebarAnimatedComponentsState } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';

export const UserSectionWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== SidebarStateKey.Opened,
})<SidebarAnimatedComponentsState>(({ theme, opened }) => ({
  alignSelf: 'flex-start',
  height: 115,
  marginTop: theme.spacing(8),
  ...(opened && {
    ...openedMixin({ theme }),
  }),
  ...(!opened && {
    ...closedMixin({ theme }),
  }),

  [theme.breakpoints.up('md')]: {
    height: 200,
  },
}));
